export const SEND_MESSAGE = "SEND_MESSAGE"
export const SEND_MESSAGE_SUCCESSFUL = "SEND_MESSAGE_SUCCESSFUL"
export const SEND_MESSAGE_FAILED = "SEND_MESSAGE_FAILED"
export const SEND_MESSAGE_RESET = "SEND_MESSAGE_RESET"

